module.exports = __webpack_public_path__ + "static/media/TH4.1a7a9ede.jpg";